module.exports = __webpack_public_path__ + "static/media/plus.0caa36c2.svg";